<template>
  <main class="main cart-page page-inside" v-if="$parent.isAuth">
    <div class="main-wrapper">
      <section class="section hero-section">
        <div class="wrapper">
          <div class="left">
            <div class="title">
              <b>Cart</b>
            </div>
            <div class="product-list">
              <div
                class="item"
                v-for="(item, i) in $parent.cartContents"
                :key="i"
              >
                <div class="preview">
                  <img :src="imgDomain + item.item.img_url" class="img" />
                </div>
                <div class="title">{{ item.item.title }}</div>
                <PriceFormatter
                  :price="displayItemPrice(item.item)"
                  rootClass="price"
                />
                <div
                  class="delete"
                  @click="$parent.removeFromCart(item.item, item.item_id)"
                >
                  <div class="desc">Delete item</div>
                </div>
                <div class="count-container">
                  <div class="count">
                    <div
                      class="count__item minus"
                      @click="$parent.removeOneFromCart(item, item.item_id)"
                    ></div>
                    <input type="number" value="1" v-model="item.count" />
                    <div
                      class="count__item plus"
                      @click="$parent.addToCart(item.item, item.item_id)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="wrapper">
              <div class="title small">
                <b>Contact information</b>
              </div>
              <div class="input-container">
                <div class="desc"><span class="red">*</span>First name:</div>
                <input type="text" placeholder="First name" v-model="name" />
              </div>
              <div class="input-container">
                <div class="desc"><span class="red">*</span>Last name:</div>
                <input type="text" placeholder="Last name" v-model="surname" />
              </div>
              <div class="input-container">
                <div class="desc"><span class="red">*</span>Phone:</div>
                <input type="tel" placeholder="Phone" v-model="phone" />
              </div>
              <div class="input-container steam-input-container">
                <div class="desc"><span class="red">*</span>Trade url:</div>
                <input type="text" placeholder="Trade url" v-model="steamId" />
              </div>
              <div class="title small">
                <b>Payment information</b>
              </div>
              <div class="input-container">
                <div class="desc"><span class="red">*</span>Country:</div>
                <Select2
                  class="select2 single"
                  v-model="country"
                  :options="countryOptions"
                  @select="selectCountry($event)"
                  placeholder="Country"
                />
              </div>
              <div class="input-list">
                <div class="input-container">
                  <div class="desc"><span class="red">*</span>City:</div>
                  <input type="text" placeholder="City" v-model="city" />
                </div>
                <div class="input-container">
                  <div class="desc"><span class="red">*</span>Post Code:</div>
                  <input
                    type="text"
                    placeholder="Post Code"
                    v-model="postCode"
                  />
                </div>
              </div>
              <div class="input-container">
                <div class="desc"><span class="red">*</span>Address:</div>
                <input type="text" placeholder="Address" v-model="address" />
              </div>
              <div class="input-container">
                <div class="chekbox-container">
                  <label class="chekbox-label">
                    <div class="chekbox-label-wrapper">
                      <input type="checkbox" name="terms" v-model="terms" />
                      <div class="checkbox"></div>
                      <span class="title">I agree with </span>
                      <router-link
                        v-if="privacyPolicyUrl"
                        :to="privacyPolicyUrl"
                        class="title"
                        >privacy policy
                      </router-link>
                      <span class="title"> and </span>
                      <router-link
                        v-if="termsAndConditionsUrl"
                        :to="termsAndConditionsUrl"
                        class="title"
                        >terms and conditions</router-link
                      >
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div class="wrapper checkout-summary">
              <div class="row">
                <div class="desc">
                  <b>Total to pay:</b>
                </div>
                <div class="title">
                  <b>
                    <PriceFormatter :price="$parent.totalSum" />
                  </b>
                </div>
                <div
                  class="desc fiat-total"
                  v-if="$parent.cartUsesInternalCurrency && $parent.totalFiat"
                >
                  ≈ {{ $parent.totalFiat }} {{ $parent.totalFiatCurrency }}
                </div>
              </div>
              <div class="button-container">
                <div class="payment-method-title">Payment method</div>
                <button
                  :class="['button balance-pay-btn', { disabled: !requiredFieldsAreFilled }]"
                  @click="submit('balance')"
                >
                  <span>Pay with balance</span>
                </button>
                <div
                  class="payment-method-separator"
                  v-if="availablePaymentMethods.length"
                >
                  <span>OR</span>
                </div>
                <div
                  :class="[
                    'button-list payment-method-list',
                    { 'has-regulations': showBlikRegulationsLink },
                  ]"
                  v-if="availablePaymentMethods.length"
                >
                  <div
                    :class="[
                      'img-btn-container',
                      { 'has-regulations': shouldShowBlikRegulations(item) },
                    ]"
                    v-for="(item, i) in availablePaymentMethods"
                    :key="i"
                  >
                    <button
                      :class="[
                        'img-btn',
                        { disabled: !requiredFieldsAreFilled },
                      ]"
                      @click="submit(item.code)"
                    >
                      <span class="payment-method-logo">
                        <img
                          v-if="item.image"
                          :src="paymentMethodImage(item.image)"
                          :alt="item.title || item.name || item.code"
                          class="img"
                        />
                        <span v-else>{{ item.title || item.name || item.code }}</span>
                      </span>
                      <span class="payment-method-label">
                        {{ item.title || item.name || item.code }}
                      </span>
                    </button>
                    <a
                      v-if="shouldShowBlikRegulations(item)"
                      href="https://www.igoriacard.com/regulamin-i-oplaty/regulamin-BLIK/"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="blik-regulations-link payment-method-regulations"
                    >
                      BLIK Regulations
                    </a>
                  </div>
                </div>
                <transition name="fade">
                  <div class="desc red" v-if="error">{{ error }}</div>
                </transition>
                <!--<button 
                  @click="submit('card')"
                  :class="['button', { disabled: !requiredFieldsAreFilled }]"
                >
                  <span>Check Out</span>
                </button> --> 
              </div>
              <!-- <div class="desc desc-14">
                <b>Minimal order amount is 5 EUR</b>
              </div> -->
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>
<script>
import Select2 from "vue3-select2-component";
import { mapGetters } from "vuex";
import PriceFormatter from "../components/PriceFormatter.vue";

export default {
  name: "Cart",
  props: [],
  components: {
    Select2,
    PriceFormatter,
  },
  data: function () {
    return {
      imgDomain: "",
      countryOptions: [],
      countryOptionsId: [],
      name: "",
      surname: "",
      phone: "",
      steamId: "",
      country: "",
      countryId: "",
      city: "",
      address: "",
      postCode: "",
      terms: false,
      error: "",
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.getProfile();
    this.getCounties();
  },
  computed: {
    ...mapGetters("staticPages", ["getTermsPage", "getPrivacyPage"]),
    privacyPolicyUrl() {
      const privacyPage = this.getPrivacyPage;
      return privacyPage
        ? { name: "TextPage", params: { identifier: privacyPage.slug } }
        : null;
    },
    termsAndConditionsUrl() {
      const termsPage = this.getTermsPage;
      return termsPage
        ? { name: "TextPage", params: { identifier: termsPage.slug } }
        : null;
    },
    requiredFieldsAreFilled() {
      let fieldsAreFilled;
      if (
        this.name &&
        this.surname &&
        this.phone &&
        this.steamId &&
        this.country &&
        this.city &&
        this.address &&
        this.postCode &&
        this.terms
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
    showBlikRegulationsLink() {
      return this.availablePaymentMethods.some((method) =>
        this.shouldShowBlikRegulations(method)
      );
    },
    ...mapGetters("app", ["currency", "settings", "availablePaymentMethods"]),
  },
  methods: {
    displayItemPrice(item) {
      return item.internal_price || item.price;
    },
    isBlikMethod(method) {
      return method && method.code && method.code.toLowerCase() === "blik";
    },
    shouldShowBlikRegulations(method) {
      return (
        this.isBlikMethod(method) &&
        this.currency === "PLN" &&
        this.settings &&
        this.settings.visitor_country === "PL"
      );
    },
    paymentMethodImage(url) {
      if (!url) return "";
      if (/^https?:\/\//.test(url)) return url;
      return this.$parent.appDomain + url;
    },
    selectCountry(event) {
      this.country = event.text;
      for (let i = 0; i < this.countryOptions.length; i++) {
        if (this.countryOptions[i] == event.text) {
          this.countryId = this.countryOptionsId[i];
        }
      }
      console.log(this.countryId);
    },
    submit(type) {
      let data = {
        name: this.name,
        surname: this.surname,
        phone: this.phone,
        steam_trade_link: this.steamId,
        tradeUrl: this.steamId,
        country: this.countryId,
        city: this.city,
        address: this.address,
        postCode: this.postCode,
        paymentType: type,
        currency: this.currency,
      };
      this.$http
        .post(process.env.VUE_APP_API + "purchase/product", data)
        .then((res) => {
          console.log(res);
          if (res.data.redirect_url) {
            window.location = res.data.redirect_url;
            return;
          }
          this.$parent.getCartContents();
          this.$parent.getUserProfile();
          this.$router.push({ path: "/success-payment" });
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          } else {
            this.error = res.response.data.message;
          }
        });
    },
    getProfile() {
      this.$http
        .get(process.env.VUE_APP_API + "user/profile")
        .then((res) => {
          this.name = res.data.name;
          this.surname = res.data.surname;
          this.phone = res.data.phone;
          this.steamId = res.data.steam_trade_link;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
        });
    },
    getCounties() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          let arr = res.data.payload;
          let newCountries = arr.map(function (item) {
            return item["title"];
          });
          let newCountriesId = arr.map(function (item) {
            return item["id"];
          });
          this.countryOptionsId = newCountriesId;
          this.countryOptions = newCountries;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
        });
    },
  },
};
</script>

<style scoped>
.balance-pay-btn {
  width: 100%;
  margin-bottom: 0;
}

.balance-pay-btn.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.cart-page .hero-section .right .checkout-summary {
  display: block !important;
  padding-top: 28px;
}

.cart-page .hero-section .right .checkout-summary .row {
  margin-bottom: 22px;
}

.cart-page .hero-section .right .checkout-summary .row .desc {
  width: auto;
}

.cart-page .hero-section .right .checkout-summary .button-container {
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: stretch !important;
}

.payment-method-title {
  margin-bottom: 12px;
  color: #909090;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
}

.cart-page .hero-section .right .checkout-summary .balance-pay-btn {
  width: 100%;
  height: 56px;
}

.cart-page .payment-method-list {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  align-items: stretch;
  gap: 10px;
  width: 100%;
}

.cart-page .payment-method-list.has-regulations {
  margin-bottom: 24px;
}

.payment-method-separator {
  width: 100%;
  margin: 16px 0;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #909090;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0;
  text-align: center;
}

.payment-method-separator::before,
.payment-method-separator::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #d7dce5;
}

.img-btn-container {
  position: relative;
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.cart-page .hero-section .right .payment-method-list .img-btn {
  width: 100%;
  min-height: 92px;
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid #aeb8c8 !important;
  border-radius: 8px !important;
  background: #fff !important;
  color: #1c1a24 !important;
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 12px !important;
  font-weight: 700;
  line-height: 16px !important;
  text-align: center;
  word-break: normal;
  overflow-wrap: anywhere;
  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
}

.cart-page .hero-section .right .payment-method-list .img-btn:hover,
.cart-page .hero-section .right .payment-method-list .img-btn:focus {
  background: #f7f9fc !important;
  border-color: #ff5f00 !important;
  color: #1c1a24 !important;
  box-shadow: 0 6px 14px rgba(28, 26, 36, 0.08);
}

.payment-method-logo {
  width: 100%;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1c1a24;
  font-size: 13px;
  line-height: 16px;
}

.payment-method-logo .img {
  max-width: 100%;
  max-height: 50px;
  width: auto;
  height: auto;
  object-fit: contain;
}

.payment-method-label {
  min-height: 15px;
  color: #1c1a24 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cart-page .hero-section .right .payment-method-list .img-btn.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.blik-regulations-link {
  color: #5277d1;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  text-align: center;
  text-decoration: none;
}

.blik-regulations-link:hover {
  text-decoration: underline;
}

.payment-method-regulations {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: 8px;
}

.fiat-total {
  width: 100%;
  margin-top: 6px;
  text-align: left;
  color: #909090;
}
</style>
